import React, { forwardRef, useImperativeHandle } from 'react';
import { Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';

const appearance = {
  variables: {
    fontFamily: '"Roobert", ui-sans-serif, sans-serif',
    colorPrimary: '#561DCF',
    borderRadius: '12px',
    colorTextSecondary: '#83807C',
  },
  rules: {
    '.Input': { borderColor: '#CECCCA', padding: '12px 16px' },
    '.Input:focus': { borderColor: '#561DCF', boxShadow: '0 0 0 3px rgba(86,29,207,0.24)' },
  },
};

const Inner = forwardRef(function Inner(_props, ref) {
  const stripe = useStripe();
  const elements = useElements();

  useImperativeHandle(ref, () => ({
    confirm: async (returnUrl) => {
      if (!stripe || !elements) return { error: { message: 'Payment form is still loading.' } };
      return stripe.confirmPayment({
        elements,
        confirmParams: { return_url: returnUrl },
        redirect: 'if_required',
      });
    },
  }));

  return <PaymentElement />;
});

const StripePaymentSection = forwardRef(function StripePaymentSection({ stripePromise, clientSecret }, ref) {
  return (
    <Elements stripe={stripePromise} options={{ clientSecret, appearance }}>
      <Inner ref={ref} />
    </Elements>
  );
});

export default StripePaymentSection;
